export default __webpack_public_path__ + "602b795a9976d745273129e6389bf749.png";